<template lang="pug">
    el-container(style="height: 100vh" direction="vertical")
      publicHeader
      
      el-main
        .error503
          h1 503
          h2 Service Unavaliable
          p Sorry. We're under maintenance.
    
      publicFooter
    
    </template>
    
    <script>
    import Header from '../public/Header.vue'
    import Footer from '../public/Footer.vue'
    
    export default {
      data() {
        return {
    
        }
      },
      title() {
        return '503'
      },
      components: {
        'publicHeader': Header,
        'publicFooter': Footer
      },
      computed: {
      }
    }
    </script>
    
    <style lang="scss" scoped>
    .error503 {
      width: 500px;
      margin: 0 auto;
      text-align: center;
    
      h1 {
        font-size: 72px;
      }
    
      p.go {
        margin-top: 50px;
        font-size: 14px;
      }
    }
    </style>